import {defineStore} from "pinia";
import axios from "axios";
import {BACKEND_BASEURL} from "@/config/config";


export const useCommunityStore = defineStore('communityStore', {
  state: () => ({}),

  actions: {

    async startEcPodlist(ecn, ecid, dateStart, dateEnd, ecnDso) {
      try {
        const urlParts = [
          "community",
          ecn,
          ecid,
          "startMembershipSync",
        ]

        return axios.post(BACKEND_BASEURL + urlParts.join('/'),
          {
            startDate: dateStart,
            endDate: dateEnd,
            ecnDso: ecnDso,
          });

      } catch (error) {
        console.error('Failed to fetch uncleanMeteringPoints:', error);
      }
    }, // getUncleanMps

  }
});
